<div class="dialog-content-max">
    <form [formGroup]="requestform">
        <div *ngIf="orgType == 'P'" class="formgrid grid">
            <div class="field col-6">
                <label for="group" class="required-label">Client Group<span>*</span></label> 
                <p-dropdown [resetFilterOnHide]="true" [options]="groupList" [filter]="true" appendTo="body" optionLabel="groupname"
                    optionValue="groupid" formControlName="group" [readonly]="onlyView" id="group"
                    name="group"></p-dropdown>
                <span class="errormessage"
                    *ngIf="requestform.get('group').invalid && (requestform.get('group').touched || requestform.get('entitytype').dirty )">
                    {{ getErrorMessage(requestform, validation_message, 'group') }}
                </span>
            </div>

        </div>
        <div class="formgrid grid">
            <div class="field col-12">
                <label for="entityname" class="required-label">Entity Name<span class="maxchars">(Max 100 chars)</span><span>*</span></label>
                <input type="text" class="form-control" id="entityname" name="entityname" formControlName="entityname"
                    placeholder="Enter Entity Name">
                <span class="errormessage"
                    *ngIf="requestform.get('entityname').invalid && (requestform.get('entityname').touched || requestform.get('entityname').dirty )">
                    {{ getErrorMessage(requestform, validation_message, 'entityname') }}
                </span>

            </div>

        </div>
        <div class="formgrid grid">
            <div class="field col-6">
                <label for="entityinitial" class="required-label">Entity Initial<span class="maxchars">(Max 20 chars)</span><span>*</span></label>
                <input type="text" class="form-control" id="entityinitial" formControlName="entityinitial"
                    [readonly]="onlyView" name="entityinitial" placeholder="Enter Entity Initial">
                <span class="errormessage"
                    *ngIf="requestform.get('entityinitial').invalid && (requestform.get('entityinitial').touched || requestform.get('entityinitial').dirty )">
                    {{ getErrorMessage(requestform, validation_message, 'entityinitial') }}
                </span>

            </div>
            <div class="field col-6">
                <label for="entitytype" class="required-label">Entity Type<span>*</span></label>
                <p-dropdown [resetFilterOnHide]="true" [options]="typelist" [filter]="true" appendTo="body"
                    optionLabel="companytype" optionValue="id" formControlName="entitytype" [readonly]="onlyView"
                    id="entitytype" name="entitytype"></p-dropdown>
                <span class="errormessage"
                    *ngIf="requestform.get('entitytype').invalid && (requestform.get('entitytype').touched || requestform.get('entitytype').dirty )">
                    {{ getErrorMessage(requestform, validation_message, 'entitytype') }}
                </span>

            </div>

        </div>
        <div class="formgrid grid">
            <div class="field col-6">
                <label for="cinnumber" class="required-label">CIN/Regn.No<span class="maxchars">(Max 23 chars)</span><span *ngIf="this.isCinRequired == 'Y'">*</span></label>
                <input type="text" class="form-control" placeholder="Enter CIN.Regn. No" formControlName="cinnumber"
                    id="cinnumber" inputId="cinnumber" name="cinnumber">
                <span class="errormessage"
                    *ngIf="requestform.get('cinnumber').invalid && (requestform.get('cinnumber').touched || requestform.get('cinnumber').dirty )">
                    {{ getErrorMessage(requestform, validation_message, 'cinnumber') }}
                </span>
            </div>
            <div class="field col-6">
                <label for="sendmail">Send Email </label>
                <p-dropdown [resetFilterOnHide]="true" [options]="sendmaillist" [filter]="true" appendTo="body"
                    optionLabel="labelname" optionValue="value" formControlName="sendmail" inputId="sendmail"
                    name="sendmail"></p-dropdown>
            </div>
        </div>

        <div class="formgrid grid" *ngIf="isEdit || onlyView">
            <div class="field col-6">
                <label for="activeflag">Active Flag</label>
                <p-dropdown [readonly]="isLegalNameChanged === 1" [resetFilterOnHide]="true" [options]="activeFlag" inputId="activeflag" [filter]="true" appendTo="body"
                    name="activeflag" optionLabel="labelname" optionValue="value"
                    formControlName="activeflag"></p-dropdown>
                <span class="errormessage" *ngIf="isLegalNameChanged === 1">
                    Entity legal name change was done for this entity, Activation of such entities are not allowed.
                </span>
            </div>
        </div>         

        <div class="formgrid grid">
            <div class="field col-12">
                <label for="entityaddress" class="required-label">Entity Address<span class="maxchars">(Max 1000 chars)</span></label> 
                <textarea [autoResize]="true" class="form-control" pInputTextarea formControlName="entityaddress"
                    id="entityaddress" name="entityaddress" placeholder="Enter Address"></textarea>
                <span class="errormessage"
                    *ngIf="requestform.get('entityaddress').invalid && (requestform.get('entityaddress').touched || requestform.get('entityaddress').dirty )">
                    {{ getErrorMessage(requestform, validation_message, 'entityaddress') }}
                </span>
            </div>
        </div>

        <div class="formgrid grid" *ngIf="userRole == '1'">
            <div  class="field col-6">
                <label for="inoperative">Inoperative </label>
                <p-dropdown [readonly]="isLegalNameChanged === 1" [resetFilterOnHide]="true" [options]="inoperativelist" [filter]="true" appendTo="body"
                    optionLabel="labelname" optionValue="value" formControlName="inoperative" inputId="inoperative"
                    name="inoperative"></p-dropdown>
                <span class="errormessage" *ngIf="requestform.get('inoperative').hasError('inoperativeConflict')">
                    If Entity is Active then it can not be Inoperative at the same time.
                </span>
                <p style="color: red; font-weight: bold;">An inoperative company is used to map a director, in
                    Secretarial system, to a related entity which is not licensed in Complinity
                    <br>
                </p>
                <span class="errormessage" *ngIf="isLegalNameChanged === 1">
                    In-operative entities can not be activated, Please raise request to Complinity Help Desk.
                </span>
            </div>
        </div>

        <div class="formgrid grid" *ngIf="requestform?.get('oldName')?.value && this.orgId != '0'">
            <div class="field col-6">
                <label for="oldName">Old Entity Name</label>
                <input type="text" class="form-control" id="oldName" formControlName="oldName"
                    readonly    name="oldName">
            </div>
            <div class="field col-6">
                <label for="effectiveDateForChange">Effective Date for Entity Name Change</label>
                <input type="text" class="form-control" id="effectiveDateForChange" formControlName="effectiveDateForChange"
                  readonly name="effectiveDateForChange">
            </div>
        </div>

    </form>

    <div class="custom-dialog-footer">
        <p-button class="m-1" label="Close" styleClass="customeclose" (click)="dismiss()"></p-button>

        <p-button class="m-1" *ngIf="this.limitedAccess == 'N'" label="{{saveTitle}}" styleClass="customesave"
            (click)="add()"></p-button>
    </div>
</div>